export default "__VITE_ASSET__CQZXVP5t__"